import React from 'react'
import { Document, Page, Text, Image } from '@react-pdf/renderer';

let desc = '';
let aux = '';
let sol = '';
if(sessionStorage.tipoInforme === '1'){
    //desc = 'Señor: \nDe mi considerción:\nSolicito a Ud.:\nSe establezcan los días de licencia ordinaria generada en el ejercicio ';

}else{
    //desc = 'El tipo de i';
}

const InformesEnfermedad = ({ datoFun }) => (
    <>
    {
        sol = '\n\n\nSolicitado el ' + datoFun.solicitado.substring(8,10) + '/' + datoFun.solicitado.substring(5,7) + '/' + datoFun.solicitado.substring(0,4)
    }
    {
        aux = 'Departamento de Recursos Humanos: \nSolicito a Uds. el usufructo de ' + datoFun.dias + ' día/s por Enfermedad desde el ' + datoFun.desde.substring(8,10) + '/' + datoFun.desde.substring(5,7) + '/' + datoFun.desde.substring(0,4)
        + ' hasta el ' + datoFun.hasta.substring(8,10) + '/' + datoFun.hasta.substring(5,7) + '/' + datoFun.hasta.substring(0,4) + ' inclusive.'
    }
    {
        desc = 'En el corriente ejercicio el funcionario N° ' + datoFun.numeroFuncionario + ' ' + datoFun.nombreFuncionario + ' ha hecho uso de:\n'
    }
    <Document>
        <Page size='A4' style={{paddingTop: 35, paddingBottom: 65, paddingHorizontal: 35}}>
            <Image style={{ width: '50%'}} src="img/Institucional.jpg"/>
            <Text style={{fontSize: 24, textAlign: 'center'}}>{'Informe Enfermedad'}</Text>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                {aux}
            </Text>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', textAlign: 'right', fontFamily: 'Times-Roman'}}>
                {sol}
            </Text>
            <Image style={{marginVertical: 8, marginLeft:300, width: 200}} src={datoFun.firmaFuncionario}/>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                {desc}
                {datoFun.listEnfermedad.map((name) => 
                    '\n' + name.dias + ' día/s de licencia por enfermedad desde ' + name.desde.substring(8,10) + '/' + name.desde.substring(5,7) + '/' + name.desde.substring(0,4) + ' hasta ' + name.hasta.substring(8,10) + '/' + name.hasta.substring(5,7) + '/' + name.hasta.substring(0,4)
                )}
            </Text>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                {'De acuerdo a lo aconsejado por el médico certificador, se concede con goce de sueldo ' + datoFun.dias + ' días de licencia por enfermedad.'}
            </Text>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', textAlign: 'right', fontFamily: 'Times-Roman'}}>
                {'Firma por Recursos Humanos: '}
            </Text>
            <Image style={{marginVertical: 8, marginLeft:300, width: 200}} src={datoFun.firmaJefeFinal}/>
        </Page>
        <Page size='A4' style={{paddingTop: 35, paddingBottom: 65, paddingHorizontal: 35}}>
            <Image style={{marginTop: 50, width:'100%', transform: 'rotate(-270deg)'}} src={datoFun.archivo}/>
        </Page>
    </Document>
    </>
);



export default InformesEnfermedad